<template>
    <div class="pasos">
        <md-steppers>
            <md-step id="first" md-label="Destinatarios">
                <vs-row>
                    <vs-col sm="12" lg="5">
                        <label for="grupo" class="labelInput">
                            Grupo
                        </label>
                        <div style="position: relative">
                            <vs-select
                                filter
                                multiple
                                collapse-chips
                                class="pt-0 pl-0"
                                id="grupo"
                                placeholder="Seleccionar grupo"
                                :key="gruposId"
                                v-model="grupo"
                                :disabled="!grupos.length">
                                <vs-option v-for="option in grupos" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </vs-select>
                        </div>
                        <p v-if="errorGrupo == true" class="red"><strong> Campo Requerido </strong></p>
                    </vs-col>
                        <vs-col sm="12" lg="2" style="margin-top: 23px;">
                        <vs-button
                            @click="getDestinatarios()"
                        >
                            Buscar
                        </vs-button>
                    </vs-col>
                </vs-row>
                <vs-row>
                     <vs-table>
                        <template #thead>
                        <vs-tr>
                            <vs-th>
                                Nombre
                            </vs-th>
                            <vs-th>
                               <vs-checkbox
                                    class="mr-1"
                                    :indeterminate="correo_institucional.length == users.length" v-model="allCheckEmail"
                                    @change="correo_institucional = $vs.checkAll(correo_institucional, users), getCorreosAlumnos(users)"
                                /> Email institucional
                            </vs-th>
                            <vs-th>
                               <vs-checkbox
                                    class="mr-1"
                                    :indeterminate="correo_familiar.length == users.length" v-model="allCheckFamiliar"
                                    @change="correo_familiar = $vs.checkAll(correo_familiar, users), getCorreos(users)"
                                /> Email(s) familiares
                            </vs-th>
                            <vs-th>
                                Programa
                            </vs-th>
                            <vs-th>
                                Grupo
                            </vs-th>
                        </vs-tr>
                        </template>
                        <template #tbody>
                        <vs-tr
                            :key="i"
                            v-for="(tr, i) in users"
                            :data="tr"
                        >
                            <vs-td>
                                <div class="d-flex">
                                    <div>
                                        <vs-avatar circle>
                                            <img :src="'/api/personas/' + tr.persona_id + '/avatar'" @error="setAltImg" alt="">
                                        </vs-avatar>
                                    </div>
                                    <div class="ml-2">
                                        <strong>{{ tr.nombre }}</strong>
                                    </div>
                                </div>
                            </vs-td>
                            <vs-td>
                                <div class="center con-checkbox">
                                    <vs-checkbox :val="tr.correo_institucional" v-model="correo_institucional"  v-if="tr.correo_institucional !== null && tr.correo_institucional !== ''">
                                       <p class="mb-0" style="font-size: 12px"> {{tr.correo_institucional}}</p>
                                    </vs-checkbox>
                                </div>
                            </vs-td>
                            <vs-td>
                                <div v-for="option in tr.familiares" :key="option.id" class="center con-checkbox">
                                    <vs-checkbox :val="option" v-model="correo_familiar" v-if="option.correo !== null && option.correo !== ''">
                                        <p class="mb-0" style="font-size: 12px;">{{option.correo }}<span class="ml-1" style="text-transform: capitalize" v-if="option.parentesco">({{option.parentesco}})</span></p>
                                    </vs-checkbox>
                                </div>
                            </vs-td>
                            <vs-td>
                                <span v-if="tr.programa !== null">{{tr.programa.nombre}}</span>
                                <span v-else>No hay programa</span>
                            </vs-td>
                            <vs-td class="text-center">
                                <span v-if="tr.grupo !== null">{{tr.grupo.nombre}}</span>
                                <span v-else>-</span>
                            </vs-td>
                        </vs-tr>
                        </template>
                        <template #notFound>
                            No hay correos electrónicos.
                        </template>
                    </vs-table>
                </vs-row>
            </md-step>

            <md-step id="second" md-label="Redactar correo" :key="compChild">
                <vs-input class="pr-0 pl-0" v-model="asunto" placeholder="Asunto" />
                <p v-if="errorCuerpo === true" style="text-align: right; color: red"><strong>Requerido</strong></p>
                <div class="d-flex mb-4">
                    <div class="mr-2">
                        <label style="background: rgb(26, 92, 255); width:100; border-radius: 5px; cursor:pointer;padding: 5px 15px; color: white; margin-bottom: 0">Archivos
                            <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()"/>
                        </label>
                    </div>
                    <div v-for="(archivo, index) in info.attachments" :key="index" class="d-flex mr-1 ml-1">
                        <div class="file-listing" style="background: #F4F4F4; padding: 8px; border-radius: 5px">{{ archivo.filename }} <i v-on:click="removeFileGuardados( archivo )" class="fas fa-times-circle"></i></div>
                    </div>
                    <div v-for="(file, key) in files" :key="key" class="d-flex mr-1 ml-1">
                        <div class="file-listing" style="background: #F4F4F4; padding: 8px; border-radius: 5px">{{ file.name }} <i v-on:click="removeFile( key )" class="fas fa-times-circle"></i></div>
                    </div>
                    <div v-if="file_excede.lenght">
                        <span v-for="(archivo, a) in file_excede" :key="a" style="color: red">{{archivo.nombre}}</span>
                    </div>
                </div>
                <div>
                    <vs-button
                        class="m-0 mb-2"
                        success
                        square
                        flat
                        @click="activePersonalizado =! activePersonalizado"
                    >
                        Personalizar correo
                    </vs-button>
                </div>
                <div class="mb-2" v-if="activePersonalizado">
                    <p>NOTA: Recuerda, donde coloques los campos personalizados, será el lugar en donde se visualizarán dentro del correo. También es importante copiar las variables completa, ejem. <i>||variable||</i>.</p>
                    <div class="d-flex" style="flex-wrap: wrap;">
                    <div class="d-flex borderCopy my-1" v-for="(valor, i) in copyCode" :key="i">
                        <div>
                            <p class="mb-0">{{valor.title}}</p>
                            <p class="mb-0 mr-1"><small>{{valor.valor}}</small></p>
                        </div>
                        <vs-button
                            color="#7d33ff"
                            danger
                            border
                            v-clipboard="valor.valor"
                        >
                            <i class="far fa-copy"></i>
                            <md-tooltip md-direction="top">Copiar</md-tooltip>
                        </vs-button>
                    </div>
                    </div>
                </div>
                <vue-editor v-model="cuerpo" :style="errorCuerpo === true ? 'border: 1px solid red' : 'border: none'"></vue-editor>
                <p v-if="errorCuerpo === true" style="text-align: right; color: red"><strong>Requerido</strong></p>
                <vs-row class="mt-3" style="justify-content:flex-end">
                    <vs-col sm="12" lg="6" class="d-flex" style="justify-content:flex-end">
                        <vs-button
                            warn
                            :disabled="institucion === '' || cicloEscolar === ''"
                            @click="getActualizar()"
                        >
                            <i class="fas fa-archive mr-1"></i> Guardar
                        </vs-button>
                        <vs-button
                            success
                            :loading="loadingEnviar"
                            :disabled="institucion === '' || cicloEscolar === ''"
                            @click="getEnviar()"
                        >
                            <i class="fas fa-paper-plane mr-1"></i> Enviar
                        </vs-button>
                    </vs-col>
                </vs-row>
            </md-step>
            
        </md-steppers>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import mailing from '../../../api/requests/mailing.js'
import VueClipboards from 'vue-clipboards'
Vue.use(VueClipboards)
export default {
    props: [
      'value',
      'info',
      'institucion',
      'cicloEscolar'
    ],
    data(){
        return{
            errorCiclo: false,
            grupo: '',
            gruposId: (new Date()).getTime(),
            grupos: [],
            errorGrupo: false,
            users: [],
            correo_institucional: [],
            correo_familiar: [],
            allCheckEmail: false,
            allCheckFamiliar: false,
            // REDACTAR
            asunto:this.info.subject,
            cuerpo: this.info.body,
            customToolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], ["image", "code-block"]],
            active: false,
            multiple: null,
            fileGuardados: this.info.attachments,
            files: [],
            compChild: 0,
            template: {},
            selectAll: false,
            selectAllAlumnos: false,
            errorAsunto: false,
            errorCuerpo: false,
            activePersonalizado: false,
            copyCode: [
                {
                    "title": "Agregar link de boleta",
                    "valor": "||link_boleta_calificacion||"
                },
                {
                    "title": "Agregar nombre de alumno",
                    "valor": "||nombre_alumno||"
                },
                {
                    "title": "Agregar correo de familiares",
                    "valor": "||correos_familiares||"
                },
                {
                    "title": "Agregar correo de alumno",
                    "valor": "||correo_alumno||"
                },
                {
                    "title": "Matrícula del alumno",
                    "valor": "||matricula||"
                }
            ],
            loadingEnviar: false,
            file_excede: []
        }
    },
    components: {
        VueEditor
    },
    created(){
        this.getGrupo()
        this.getArchivos()
    },
    methods:{
        varibleCopy() {
            try{
                this.$refs.variable.select()
                document.execCommand('copy')
                this.$vs.notification({
                    color: 'rgb(59,222,200)',
                    title: 'Texto copiado'
                })
            }catch{

            }
        },
        async getGrupo() {
            if(this.cicloEscolar !== ''){
                try {
                    let params = {
                        "institucion_id": this.institucion,
                        "ciclo_escolar_id": this.cicloEscolar,
                    }
                    const { data: response } = await mailing.getGrupo(this.institucion, params)
                    this.grupos = response
                    this.gruposId = (new Date()).getTime()
                }
                catch{
                    
                }
            }
        },
        async getDestinatarios(){
          const loading = this.$vs.loading()
            try {
                let params = {
                    "ciclo_escolar_id": this.cicloEscolar,
                    "institucion_id": this.institucion,
                    "grupo_administrativo_id": this.grupo,
                }
                this.correo_institucional = []
                this.correo_familiar = []
                const { data: response } = await mailing.getDestinatarios(params)
                this.users = response
                this.selectAll = false
                this.allCheckFamiliar = false
                loading.close()
            }
            catch{
                loading.close()
                this.$vs.notification({
                    title: 'Algo salio mal.',
                    text: 'Por favor contacte al administrador.'
                })
            }    
        },
        
        getCorreos(users){
            this.selectAll = !this.selectAll
            this.correo_familiar = []
            if(this.selectAll){
                users.forEach(i => {
                    i.familiares.forEach(j => {
                        this.correo_familiar.push(j)
                    })
                })
            }
        },
        getCorreosAlumnos(users){
            this.selectAllAlumnos = !this.selectAllAlumnos
            this.correo_institucional = []
            if(this.selectAllAlumnos){
                users.forEach(i => {
                    i.correosInstitucionales.forEach(j => {
                        this.correo_institucional.push(j)
                    })
                })
            }
        },
        async getEnviar(){
            if(!this.correo_familiar[0] && !this.correo_institucional[0]){
                this.$vs.notification({
                    title: 'No tienes ningún correo seleccionado',
                    text: `Debes tener algún correo seleccionado para poder enviar el correo.`
                })
                return false
            }

            if(this.cuerpo === '' && this.asunto === ''){
                this.errorAsunto = true
                this.errorCuerpo = true
            }

            if(this.asunto === ''){
                this.errorAsunto = true
                return false
            }else{
                this.errorAsunto = false
            }

            if(this.cuerpo === ''){
                this.errorCuerpo = true
                return false
            }else{
                this.errorCuerpo = false
            }
            
            try {
                const formData = new FormData();
                formData.append('subject', this.asunto)
                formData.append('body', this.cuerpo)
                formData.append('institucion_id', this.institucion)
                formData.append('ciclo_escolar_id', this.cicloEscolar)
                    for( var i = 0; i < this.files.length; i++ ){
                        let file = this.files[i];
                        formData.append('attachments[]', file, file.name);;
                    }
                const { data: response } = await mailing.getTemplate(formData)
                this.template = response
                    const recipient = []
                    if(this.correo_familiar[0]){
                        this.correo_familiar.forEach(i => {
                            if(i.correo !== null && i.correo !== ''){
                                const obj = {
                                    'name': i.nombre,
                                    'email': i.correo,
                                    'persona_id': i.alumno_id,
                                    'type': 'familiar',
                                    'avatar': ''
                                }
                                recipient.push(obj)
                            }

                        })
                    }
                    if(this.correo_institucional){
                        this.users.forEach(element => {
                            this.correo_institucional.forEach(i => {
                                if(i == element.correo_institucional){
                                    if(element.correo_institucional !== null && element.correo_institucional !== ''){
                                        const obj = {
                                            'name': element.nombre,
                                            'email': element.correo_institucional,
                                            'persona_id': element.persona_id,
                                            'type': 'alumno',
                                            'avatar': element.avatar
                                        }
                                        recipient.push(obj)
                                    }
                                }
                            })
                        })
                    }
                    const base = {mail_id: response.id };
                    const soli = {recipients: recipient}
                    const payload = Object.assign(base, soli);
                    this.getEnviarDatos(payload)
                    
            }
            catch{
                this.$vs.notification({
                    color: 'danger',
                    title: 'Algo salio mal.',
                    text: 'Por favor contacte al administrador.'
                })
            } 
        }, 
        async getEnviarDatos(payload){
                const loading = this.$vs.loading()
                this.loadingEnviar = true
            try {
                const { data: response } = await mailing.getEnviarDatos(payload)
                loading.close()
                this.$emit('refreshTable', true);
                this.correo_institucional = []
                this.correo_familiar = []
                this.asunto = ''
                this.cuerpo = ''
                this.info.attachments = []
                this.allCheckEmail = false
                this.allCheckFamiliar = false,
                this.selectAll = false
                this.selectAllAlumnos = false
                
                this.$vs.notification({
                    progress: 'auto',
                    duration: 8000,
                    color: 'success',
                    position: null,
                    title: 'El correo se ha enviado con éxito',
                    text: 'En el apartado de "Bandeja de salida" podrás ver el progreso del envio'
                })
                
                this.loadingEnviar = false
            }
            catch{
                loading.close()
                this.$vs.notification({
                    color: 'danger',
                    title: 'Algo salio mal.',
                    text: 'Por favor contacte al administrador.'
                })
                this.loadingEnviar = false
            } 

        },
        async getActualizar(){

            if(this.cuerpo === '' && this.asunto === ''){
                this.errorAsunto = true
                this.errorCuerpo = true
            }

            if(this.asunto === ''){
                this.errorAsunto = true
                return false
            }else{
                this.errorAsunto = false
            }

            if(this.cuerpo === ''){
                this.errorCuerpo = true
                return false
            }else{
                this.errorCuerpo = false
            }
            const formData = new FormData();
            formData.append('mail_id', this.info.id)
            formData.append('subject', this.asunto)
            formData.append('body', this.cuerpo)
            formData.append('institucion_id', this.institucion)
            formData.append('ciclo_escolar_id', this.cicloEscolar)
            for( var i = 0; i < this.files.length; i++ ){
                let file = this.files[i];
                formData.append('attachments[]', file, file.name);
            }
            const { data: response } = await mailing.getActualizar(formData)
            this.$emit('refreshTable', true);
                this.$vs.notification({
                    color: 'success',
                    title: 'El correo se guardo con éxito'
                })
        },
        addFiles(){
            this.$refs.files.click();
        },
        submitFiles(){
            let formData = new FormData();
            for( var i = 0; i < this.files.length; i++ ){
            let file = this.files[i];

            formData.append('files[' + i + ']', file);
            }
            axios.post( '/select-files',
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
            ).then(function(){
            console.log('SUCCESS!!');
            })
            .catch(function(){
            console.log('FAILURE!!');
            });
        },
        handleFilesUpload(){
            let uploadedFiles = this.$refs.files.files;
            for( var i = 0; i < uploadedFiles.length; i++ ){
                if(uploadedFiles[i].size < 5000){
                    this.files.push( uploadedFiles[i] );
                }else{
                    this.file_excede.push( uploadedFiles[i] )
                }
            }
        },
         removeFile( key ){
            this.files.splice( key, 1 );
        },
        async removeFileGuardados(info ){
            this.info.attachments.splice(this.info.attachments.indexOf(info.id), 1 );
            let params = {
                'attachment_id': info.id
            }
            const { data: response } = await mailing.removeFile(params)
        },
        getArchivos(){
            const archivos = this.info.attachments
            archivos.forEach(i => {
            })
        },
        setAltImg(event) {
            event.target.src = "https://sigem.maristas.mx/img/default-avatar.jpg"
        },
    },
    watch: {
        cicloEscolar() {
            this.grupo = ''
            this.getGrupo()
            if(this.info.attachments[0]){
                this.getArchivos()
            }
            this.users = []
        },
        institucion(){
            this.grupo = ''
            this.getGrupo()
            this.users = []
        },
        value (val) {
            this.active = val
        },
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        // info(){
        //     console.log("entro aqui info")
        //     if(this.info.attachments[0]){
        //         this.getArchivos()
        //     }
        // }
    }
}
</script>

<style>
    .pasos .md-steppers .md-steppers-navigation {
        box-shadow: none !important;
        color: red;
    }

    .vs-checkbox-label{
        margin-bottom: 0 !important;
    }
    input[type="file"]{
    position: absolute;
    top: -500px;
  }

  div.file-listing{
    width: auto;
  }

  span.remove-file{
    color: red;
    cursor: pointer;
    float: right;
  }
    .vs-avatar img{
        object-fit:contain;
    }
</style>